var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttendanceImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2216_5892)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2216_5892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 9.36583C10.9508 9.36583 8.33333 11.9825 8.33333 15.1992C8.33333 18.3975 10.9508 21 14.1667 21C17.3825 21 20 18.3833 20 15.1667C20 11.9683 17.3825 9.36583 14.1667 9.36583ZM14.1667 19.3333C11.8692 19.3333 10 17.4783 10 15.1992C10 12.9017 11.8692 11.0325 14.1667 11.0325C16.4642 11.0325 18.3333 12.8875 18.3333 15.1667C18.3333 17.4642 16.4642 19.3333 14.1667 19.3333ZM15.5892 15.4108C15.915 15.7367 15.915 16.2633 15.5892 16.5892C15.4267 16.7517 15.2133 16.8333 15 16.8333C14.7867 16.8333 14.5733 16.7517 14.4108 16.5892L13.5775 15.7558C13.4208 15.5992 13.3333 15.3875 13.3333 15.1667V13.5C13.3333 13.04 13.7058 12.6667 14.1667 12.6667C14.6275 12.6667 15 13.04 15 13.5V14.8217L15.5892 15.4108ZM20 6.83333V8.5C20 8.96 19.6275 9.33333 19.1667 9.33333C18.7058 9.33333 18.3333 8.96 18.3333 8.5V6.83333C18.3333 5.455 17.2117 4.33333 15.8333 4.33333H4.16667C2.78833 4.33333 1.66667 5.455 1.66667 6.83333V7.66667H9.16667C9.62667 7.66667 10 8.04 10 8.5C10 8.96 9.62667 9.33333 9.16667 9.33333H1.66667V16.8333C1.66667 18.2117 2.78833 19.3333 4.16667 19.3333H7.5C7.96 19.3333 8.33333 19.7067 8.33333 20.1667C8.33333 20.6267 7.96 21 7.5 21H4.16667C1.86917 21 0 19.1308 0 16.8333V6.83333C0 4.53583 1.86917 2.66667 4.16667 2.66667H5V1.83333C5 1.37333 5.37333 1 5.83333 1C6.29333 1 6.66667 1.37333 6.66667 1.83333V2.66667H13.3333V1.83333C13.3333 1.37333 13.7058 1 14.1667 1C14.6275 1 15 1.37333 15 1.83333V2.66667H15.8333C18.1308 2.66667 20 4.53583 20 6.83333Z",
    fill: "#3D3E58"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2216_5892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.6667,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2216_5892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceImg);
export default __webpack_public_path__ + "static/media/AttendanceImg.b0bd29f61f9a26af162611089a2be59e.svg";
export { ForwardRef as ReactComponent };